import $ from 'jquery';
import getCclHtml from './getCclHtml';
import debounce from './lodash_debounce/debounce';
import { httpsToHttp, makeAjaxRequestUri, toParamString, toRelativeProtocol, toParamObj } from './url';
import inherit from './inherit';
import memoize from './memoize';
import makeRequeryUrl from './makeRequeryUrl';

function camelToHyphen(str){
  return str.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
}

function toCssString(obj) {
  let arr = [];
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      arr.push(`${camelToHyphen(key)}:${obj[key]}`);
    }
  }
  return arr.join(';');
}

/**
 * makeDateStr
 * 공통
 * 날짜형태의 데이터를 yyyy.mm.dd 형태로 만들어서 반환하는 메소드
 * @param date_str 원본날짜 문자열
 * @returns String 변환된 문자열
 */
function makeDateStr(date_str) {
  if (date_str.length >= 8) {
    return $.format.dateformat(date_str, 'yyyy.MM.dd');
  } else {
    return date_str;
  }
}

export function removeEmpty(obj) {
  const newObj = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && obj[key]) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

export {
  getCclHtml,
  httpsToHttp,
  makeAjaxRequestUri,
  toParamObj,
  toCssString,
  debounce,
  makeDateStr,
  toParamString,
  inherit,
  toRelativeProtocol,
  memoize,
  makeRequeryUrl
};


/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/index.js
 **/